import { render, staticRenderFns } from "./BlocoStatusCertificacoes.vue?vue&type=template&id=f102e19c&scoped=true"
import script from "./BlocoStatusCertificacoes.vue?vue&type=script&lang=js"
export * from "./BlocoStatusCertificacoes.vue?vue&type=script&lang=js"
import style0 from "./BlocoStatusCertificacoes.vue?vue&type=style&index=0&id=f102e19c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f102e19c",
  null
  
)

export default component.exports